import { CreateRouterOptions } from '@/typings/common'

import { registerModule } from './store'


type Options = Required<CreateRouterOptions>


const createModule = (options: Options) => {
  registerModule(options)
  return []
}

export default createModule
